import React, {useCallback, useState} from 'react';
import {Button, Container, Col, Row} from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';
import {speakers} from './data.json';
import './TntgSpeaker.scss';

function TntgItem({id, title, description, idx, image, showClassNumber, ...props}) {
  return (
    <div className="tntg-speaker py-3">
      <Container className="p-0" fluid>
        <Row className="d-flex align-items-center justify-content-center">
          <Col xs="8" sm="6" lg="3" xl="2" className="mb-4 mb-lg-0">
            <img className="tntg-speaker-img img-fluid rounded-sm mx-auto" src={image} />
          </Col>
          <Col xs="12" lg="9" xl="10">
            <h3 className="tntg-speaker-name text-condensed text-800 text-center text-lg-left mb-2">
              {showClassNumber ? (
                <>
                  <span className="text-green">{`Class ${idx}`}</span> —{' '}
                </>
              ) : null}
              <ReactMarkdown
                source={title}
                tag={React.Fragment}
                renderers={{root: ({children}) => <>{children}</>, paragraph: ({children}) => <>{children}</>}}
              />
            </h3>
            <ReactMarkdown className="tntg-speaker-description" source={description} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

TntgItem.defaultProps = {};

export default function TntgSpeakerList({id, showClassNumber, ...props}) {
  return speakers.map((speaker, i) => (
    <TntgItem {...speaker} key={speaker.id} showClassNumber={showClassNumber} idx={i + 1} />
  ));
}
